import { render, staticRenderFns } from "./ForgotModal.vue?vue&type=template&id=29693b61&scoped=true&"
import script from "./ForgotModal.vue?vue&type=script&lang=js&"
export * from "./ForgotModal.vue?vue&type=script&lang=js&"
import style0 from "./ForgotModal.vue?vue&type=style&index=0&id=29693b61&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../buyers/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29693b61",
  null
  
)

export default component.exports